<template>
</template>

<script>
    /**
     * Usage examples:
     *
     * <trianglify
     *      color-scheme="horizontal-primary-simple"
     *      apply-to-element-selector=".modal-wrapper__inner"
     *      should-use-png="true">
     * </trianglify>
     *
     * This will result in a trianglify PNG pattern being generated and appended to the first "mode-wrapper-inner" class is found in the DOM.
     *
     * Color Schemes:
     * - dark
     * - horizontal-primary
     * - horizontal-primary-inverted
     * - horizontal-primary-simple
     * - secondary
     * - funky-primary-to-secondary
     */
    import Trianglify from 'trianglify';
    export default {
        data: function () {
            return {
                imageOffsetX: this.offsetPositionX,
                imageOffsetY: this.offsetPositionY,
                hasResized: false,
            }
        },
        mounted() {
            this.app = document.getElementById('app');
            this.initDefaultGrid();
            //window.addEventListener('resize', _.debounce(this.adjustSize, 100));
        },
        methods: {
            generateGrid(width, height) {
                let pattern = '';

                // Store defaults
                if (!width) {
                    width = (this.containerWidth != 0) ? parseInt(this.containerWidth) : this.$el.clientWidth;
                }
                if (!height) {
                    height = (this.containerHeight != 0) ? parseInt(this.containerHeight) : app.offsetHeight + 800;
                }
                if (this.shouldSpanWindow != 0) {
                    width = window.innerWidth;
                    height = window.innerHeight;
                    document.body.classList.add('fixed-bg-image');
                }

                // Define the color scheme.
                if (this.colorScheme == 'dark') {
                    pattern = Trianglify({width: width, height: height, x_colors: ['#20263C', '#2c2f33', '#3F4B77']});
                }
                else if (this.colorScheme == 'horizontal-primary') {
                    const isDesktop = window.innerWidth > 1680;
                    // Slightly adjust the color of the generated triangle based on screen resolution.
                    const adjustedColorNextToSidebar = isDesktop ? 'black' : '#23272a';
                    pattern = Trianglify({
                        width: width,
                        height: height,
                        y_colors: [
                            '#23272a',
                            '#23272a',
                            '#23272a',
                            '#23272a',
                            '#272c3e',
                            '#434c6d',
                            '#4b5a90',
                            '#6275bb',
                            '#7289da',
                            '#6275bb',
                            '#4b5a90',
                            '#434c6d',
                            '#272c3e',
                            '#23272a',
                            '#23272a',
                            '#23272a',
                            '#23272a',
                        ],
                        x_colors: [
                            '#23272a',
                            '#23272a',
                            adjustedColorNextToSidebar,
                            adjustedColorNextToSidebar,
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                        ]
                    });
                }
                else if (this.colorScheme == 'horizontal-primary-inverted') {
                    pattern = Trianglify({
                        width: width,
                        height: height,
                        y_colors: [
                            '#7289da',
                            '#6275bb',
                            '#4b5a90',
                            '#434c6d',
                            '#272c3e',
                            '#23272a',
                            '#23272a',
                            '#23272a',
                            '#23272a',
                            '#272c3e',
                            '#434c6d',
                            '#4b5a90',
                            '#6275bb',
                            '#7289da',
                        ],
                        x_colors: [
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                        ]
                    });
                }
                else if (this.colorScheme == 'horizontal-primary-simple') {
                    pattern = Trianglify({
                        width: width,
                        height: height,
                        y_colors: [
                            '#23272a',
                            '#23272a',
                            '#23272a',
                            '#23272a',
                            '#272c3e',
                            '#434c6d',
                            '#4b5a90',
                            '#6275bb',
                            '#7289da',
                            '#6275bb',
                            '#4b5a90',
                            '#434c6d',
                            '#272c3e',
                            '#23272a',
                            '#23272a',
                            '#23272a',
                            '#23272a',
                        ],
                        x_colors: [
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                            'black',
                        ]
                    });
                }
                else if (this.colorScheme == 'secondary') {
                    pattern = Trianglify({width: width, height: height, x_colors: ['#fcbe5d', '#2c2f33', '#23272a']});
                }
                else if (this.colorScheme == 'funky-primary-to-secondary') {
                    pattern = Trianglify({width: width, height: height, x_colors: ['#fcbe5d','#212529'].reverse(), y_colors: [
                        '#23272a',
                        '#23272a',
                        '#23272a',
                        '#23272a',
                        '#272c3e',
                        '#434c6d',
                        '#4b5a90',
                        '#6275bb',
                        '#7289da',
                        '#6275bb',
                        '#4b5a90',
                        '#434c6d',
                        '#272c3e',
                        '#23272a',
                        '#23272a',
                        '#23272a',
                        '#23272a',
                    ]});
                }
                else if (this.colorScheme == 'premium') {
                    pattern = Trianglify({width: 300, height: 300, x_colors: ['#2DDD9E','#25B380'], y_colors: [
                    ]});
                }
                else {
                    // The default primary color.
                    pattern = Trianglify({width: width, height: height, x_colors: ['#7289da', '#2c2f33', '#23272a']});
                }

                if (this.shouldUsePng == 0 || this.shouldUsePng === undefined) {
                    // Generate the canvas Trianglify pattern.
                    pattern = pattern.canvas();
                } else {
                    // Just return a generated PNG as the Trianglify pattern
                    return pattern.png();
                }

                // Apply the rotation class.
                if (this.rotation !== 0) {
                    pattern.classList.add('rotate--' + this.rotation);
                }

                // Return the pattern in canvas form.
                return pattern;
            },
            appendNewGrid() {
                if (this.shouldUsePng == 0 || this.shouldUsePng === undefined) {
                    const oldGrid = this.$el.querySelector('canvas');
                    if (oldGrid) {
                        const newGrid = this.generateGrid();
                        oldGrid.parentNode.insertBefore(newGrid, oldGrid.nextSibling);
                        oldGrid.parentNode.removeChild(oldGrid);
                    }
                } else {

                   let target;
                   if (this.applyToElementSelector != 0) {
                       let elements = document.querySelectorAll(`${this.applyToElementSelector}`);
                       if (elements.length == 1) {
                           // If only one element exists in the DOM, append the background to it.
                           target = elements[0];
                       } else {
                           // Look for the closest element that has this class.
                           target = this.$el.closest(`${this.applyToElementSelector}`);
                       }
                   } else {
                       // All else fails, we append it to the body.
                       target = document.documentElement;
                   }
                   // Bail if no element exists in the DOM.
                   if (!target) {
                       console.warn('Trangles.vue: Please make sure the class assigned to apply-to-element-selector exists on the page.');
                       return;
                   }
                   // Attach the background image.
                   this.attachImageToElement(target);
                   if (this.autoOffsetPosition != 0 ) {
                       this.imageOffsetY = (window.innerHeight + 300) * -1;
                   }
                   if (this.imageOffsetX) {
                       target.style.backgroundPositionX = `${this.imageOffsetX}px`;
                   }
                   if (this.imageOffsetY) {
                       target.style.backgroundPositionY = `${this.imageOffsetY}px`;
                   }
                }
            },
            attachImageToElement(targetEl) {
                targetEl.style.background = `url(${this.generateGrid()})`;
            },
            adjustSize() {
                if (!this.hasResized) {
                    this.hasResized = true;
                    this.appendNewGrid();
                }
            },
            initDefaultGrid() {
                if (this.shouldUsePng == 0 || this.shouldUsePng === undefined) {
                    // Append the pattern canvas.
                    this.$el.appendChild(this.generateGrid());
                } else {
                    // Run through the append function to attach the png to the body.
                    this.appendNewGrid();
                }
            },
        },
		watch: {
			// Watch Event Handler.
		},
        props: ['colorScheme', 'shouldUsePng', 'rotation', 'containerWidth', 'containerHeight', 'applyToElementSelector', 'shouldSpanWindow', 'autoOffsetPosition', 'offsetPositionX', 'offsetPositionY' ]
    }
</script>
